export default __webpack_public_path__ + "71ea8b7cbd17f123d66af70142a507b5.png";